import React, {useMemo, useState, useEffect} from 'react';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {
    Box, Button,
    Checkbox,
    FormControl, InputLabel,
    Link,
    MenuItem,
    Modal,
    Select,
    Switch, TextField,
    Typography,
    Input,Autocomplete,
    styled
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Collapse from "@mui/material/Collapse";
import { ReactComponent as MarkerIcon } from '../../../../assets/svg/ShoppingOperation/markerIcon.svg'

import {mainApi} from "../../../../store/services/mainApi";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from '@mui/material/AvatarGroup';

import ListItemText from "@mui/material/ListItemText";
import ListItemButton from '@mui/material/ListItemButton';
import {useDispatch} from "react-redux";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramAppIcon from "@mui/icons-material/Telegram";
import StatusBuy from "../../../BuyerOperecion/Switch/List/Status/StatusBuy";
import './ItemsProductionAccordion.scss'
import { ReactComponent as MB } from '../../../../assets/svg/ShoppingOperation/MBIcon.svg'
import { ReactComponent as Bcn } from '../../../../assets/svg/ShoppingOperation/BcnIcon.svg'
import '../../../LogisticOperation/LogisticOperation.scss'
import './ItemsProductionAccordion.scss'

function stringToColor(string) {
    let hash = 0;
    let i;

    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name),
        },
        children: `${name.split(' ').length < 2 ? name.split(' ')[0][0] : name.split(' ')[0][0] + "" + name.split(' ')[1][0] }`,
    };
}

const pavilionsColors = [
  {value: 'MB', name: 'MB', color: '#A5A38C'},
  {value: '1', name: '1A', color: '#5FC56E'},
  {value: '2', name: '2B', color: '#ff2000'},
  {value: '3', name: '3C', color: '#FF8C04'},
  {value: '4', name: '4D', color: '#0351ff'},
  {value: '5', name: '5E', color: '#b403ff'},
  {value: '6', name: '6F', color: '#a41010'},
  {value: '7', name: '7G', color: '#06c0b0'},
  {value: '0', name: 'PVL', color: '#DCD024'},
]


const ItemsProductionAccordionItem = ({pavObj, redTotal, statusBackground, statuses, editChange, handleSendDriverInformSendWhatsapp, setEditChange, setSelectedItems, drivers, uniqueProveedors, redCogs, item, openRows, toggleRowOpen, selectedItems, checkBoxStyle, handleNestedSelect, handleTopLevelSelect, userColumnsFields, rowStyleMap}) => {
  const dispatch = useDispatch()
  const [createDriver] = mainApi.useDriverListCreateMutation()
  const [deleteDriver] = mainApi.useDriverListDeleteMutation()
  const [updateDriver] = mainApi.useDriverListUpdateMutation()

  const [changeObj] = mainApi.useChangeOrderObjMutation()
  const [changeObjStock] = mainApi.useChangeObjStockMutation()
  const [changeObjProveedor] = mainApi.useChangeObjProveedorMutation()
  const [changeObjPrice] = mainApi.useChangeObjEntryPriceMutation()
  const [changeObjInform] = mainApi.useChangeInnerDescriptionMutation()

  const [open, setOpen] = useState(false)

  const [changeModal, setChangeModal] = useState(false)
  const [selectedContact, setSelectedContact] = useState({})
  const [selectedContactName, setSelectedContactName] = useState('')
  const [selectedContactPhone, setSelectedContactPhone] = useState('')

  const [createModal, setCreateModal] = useState(false)
  const [createName, setCreateName] = useState('')
  const [createPhone, setCreatePhone] = useState('')

  const [changeCompradorOrderId, setChangeCompradorOrderId] = useState([])

  const [changeComprador, setChangeComprador] = useState(false)

  // console.log(item)

  const [selectProveedor, setSelectProveedor] = useState(Array.isArray([... new Set(item.orders.map((el) => el.items).flat().map((el) => el.proveedor))]) ? [... new Set(item.orders.map((el) => el.items).flat().map((el) => {
    if(el?.proveedorsArray){
      let arrNames = el?.proveedorsArray
      // console.log(arrNames)
      return [...arrNames]
    }else{
      return []
    }
  }).flat())].filter((el) => el.tradeName !== '-') : [])

  const [inputReserve, setInputReserve] = useState((item.totalReserve ? parseFloat(item.totalReserve) : item.totalReserve) || null)

  const [inputStock, setInputStock] = useState((item.totalStock ? parseFloat(item.totalStock) : item.totalStock) || null)
  const [inputEntryPrice, setInputEntryPrice] = useState(item.orders[0].items.ourPrice)

  const [inputProveedor, setInputProveedor] = useState([])

  // useEffect(() => {
  //   console.log(inputProveedor);
  // }, [inputProveedor])

  const [updateProductsManager] = mainApi.useUpdateProductsManagerMutation()


  const [checked, setChecked] = useState([...item.orders.map(el => el.items.comprador).flat()].filter((item, index, self) =>
      item != null && self.findIndex(el => el?._id === item?._id) === index
  ) || []);


  const [compradorState, setCompradorState] = useState(() =>
    item.orders.reduce((state, order) => {
      state[order._id] = order.items.comprador || [];
      return state;
    }, {})
  );

  const handleToggle = (value) => () => {
    if (checked.find(el => el._id === value._id)) {
      let compradorArray = checked.filter(el => el._id !== value._id)

      changeCompradorOrderId.forEach(ell => {
        setCompradorState((prevState) => ({
          ...prevState,
          [ell._id]: compradorArray
        }));
        setChecked(Object.values({...compradorState, [ell._id]: compradorArray}).flat().filter((item, index, self) =>
          item != null && self.findIndex(el => el?._id === item?._id) === index
        ))
        return 1
      })
    } else {
      let compradorArray = [...checked, value]

      changeCompradorOrderId.forEach(ell => {
        setCompradorState((prevState) => ({
          ...prevState,
          [ell._id]: compradorArray
        }));

        setChecked(Object.values({...compradorState, [ell._id]: compradorArray}).flat().filter((item, index, self) =>
          item != null && self.findIndex(el => el?._id === item?._id) === index
        ))

        return 1
      })
    }
  };


  const handleSaveEditInform = () => {
    const user = JSON.parse(localStorage.getItem('acc'));
    const currentDate = new Date().toLocaleDateString('en-GB'); // Формат DD.MM.YYYY

    updateProductsManager({
      sku: item.sku,
      reserve: parseInt(inputReserve) ? parseInt(inputReserve) : (inputReserve || 0),
      stock: parseInt(inputStock) ? parseInt(inputStock) : (inputStock || 0),
      updatedBy: user.name,
      updatedAt: currentDate,
    }).unwrap()
    .then((res) => {
      setChangeModal(false)
      alert("Saved Stock, Reserve...")
      dispatch(mainApi.util.invalidateTags(['itemsOperacion']))
    });

    changeObjProveedor({
      orders: item.orders,
      proveedorsArray: [...inputProveedor],
      pavilionData: [...inputProveedor]?.map(el => {
        return {
          "pavilion": el.pavilion,
          "price": item.ourPrice,
          "sku": item.sku,
          "name": item.name,
          "img": item.img,
          "quantity": item.quantity
        }
      }),
      pavilion: [...inputProveedor].map(el => el.pavilion),
      ourPrice: inputEntryPrice,
      sku: item.orders[0].items.sku,
    })
    .unwrap()
    .then((res) => {
      setChangeModal(false)
      //alert("Saved Proveedor...")
      dispatch(mainApi.util.invalidateTags(['itemsOperacion']))
    });
  }


  const handleSaveComprador = () => {
    changeObj({
      orders: changeCompradorOrderId,
      comprador: checked
    })
    .unwrap()
    .then((res) => {
      setChangeModal(false)
      alert("Saved...")
      dispatch(mainApi.util.invalidateTags(['itemsOperacion']))
    })
  }

  const handleDeleteDriver = async () => {
    if (confirm('Are you sure you want to delete this driver?')) {
      await deleteDriver(selectedContact._id).then(() => {
        dispatch(mainApi.util.invalidateTags(['Drivers']))
        setChangeModal(false)
      })
      setSelectedContact({})
    }
  }

  const handleCreateDriver = async () => {
    if (confirm('Are you sure you want to create this driver?')) {
      await createDriver({
        name: createName,
        phone: createPhone,
      })
      .then(() => {
        dispatch(mainApi.util.invalidateTags(['Drivers']))
        setCreateModal(false)
      })
      .catch((err) => {
        alert(err)
      })
    }
  }

  const handleUpdateDriver = async () => {
    if (confirm('Are you sure you want to update this driver?')) {
      await updateDriver({
        _id: selectedContact._id,
        name: selectedContactName,
        phone: selectedContactPhone,
      }).then(() => {
        dispatch(mainApi.util.invalidateTags(['Drivers']))
        setChangeModal(false)
      })
    }
  }
  const filterSwitch = () => {
    if (redTotal && redCogs) {
      return ((((inputStock) - (parseFloat(item.totalQuantity) + (inputReserve))) >= 0) && (parseFloat(item.ourPrice) >= 0))
    } else if (redTotal) {
      return (((inputStock) - (parseFloat(item.totalQuantity) + (inputReserve))) >= 0)
    } else if (redCogs) {
      return (parseFloat(item.ourPrice) >= 0)
    }
  }

  const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
    padding: 0,
    '& .MuiSvgIcon-root': {
      width: 24,
      height: 24,
      borderRadius: '7px',
      border: '1px solid #d9d9d9',
      transition: 'all 0.2s',
    },
    '&.Mui-checked': {
      color: '#176318',
      '& .MuiSvgIcon-root': {
        borderColor: '#176318',
      }
    },
    '&:hover': {
      '& .MuiSvgIcon-root': {
        borderColor: '#176318',
        backgroundColor: 'rgba(23, 99, 24, 0.05)'
      }
    }
  }));
  const CheckedIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.15124 14.737C6.7509 15.2616 5.96111 15.2614 5.561 14.7366L2.407 10.5995C2.00764 10.0756 1.21971 10.0743 0.818564 10.5968L0.465911 11.0561C0.190927 11.4143 0.190078 11.9123 0.46384 12.2714L5.56063 18.9569C5.96084 19.4818 6.75092 19.4818 7.15114 18.9569L19.5378 2.70918C19.8108 2.3511 19.8108 1.85472 19.5378 1.49663L19.1917 1.04265C18.7916 0.517833 18.0018 0.517653 17.6015 1.04229L7.15124 14.737Z" fill="#176318" />
    </svg>
  );
  const CheckIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.15124 14.737C6.7509 15.2616 5.96111 15.2614 5.561 14.7366L2.407 10.5995C2.00764 10.0756 1.21971 10.0743 0.818564 10.5968L0.465911 11.0561C0.190927 11.4143 0.190078 11.9123 0.46384 12.2714L5.56063 18.9569C5.96084 19.4818 6.75092 19.4818 7.15114 18.9569L19.5378 2.70918C19.8108 2.3511 19.8108 1.85472 19.5378 1.49663L19.1917 1.04265C18.7916 0.517833 18.0018 0.517653 17.6015 1.04229L7.15124 14.737Z" fill="none" />
    </svg>
  );

  function renderLocation (mode, location, pavilion, key) {
    if (mode == 'B') {
      return <Box
        key={key}
        className='locationPattern'
        sx={{ background: `#7558F533`, color: '#7558F5'}}
      >
        <Box 
          className='locationPattern__icon'
          sx={{ background: `#7558F5`, color: '#fff'}}
        >
          <MarkerIcon />
        </Box>
        <p>{location}</p>
      </Box>
    } else if (mode == 'M') {
      if (!pavilion?.split(',')[0]) return
      const pavLoc = pavilion?.split(',')[0] 
      const pav = pavilionsColors.find((el) => el.value == pavLoc[0]) ? pavilionsColors.find((el) => el.value == pavLoc[0]) : pavilionsColors[0]
      // console.log(pavilionsColors);

      return <Box
        key={key}
        className='locationPattern'
        sx={{ background: `${pav.color}33`, color: pav.color}}
      >
        <Box 
          className='locationPattern__icon'
          sx={{ background: pav.color, color: '#fff'}}
        >
          {pav.name}
        </Box>
        <p>{pavLoc}</p>
      </Box>
    } else {
      return <></>
    }
  }

  const cityIconRender = (mode) => {
    // console.log(selectProveedor[0]?.tradeName[0]);
    if (mode == 'B') {
      return <Bcn height={25}/>;
    } else if (mode == 'M') {
      return <MB height={25}/>;
    } else {<></>}
  }
  const navData = item?.orders[0].items.proveedorsArray
  // console.log(navData);
  
  return (
    <React.Fragment key={item._id}>
      <TableRow sx={{ '& > *': { borderBottom: 'unset', display: filterSwitch() && "none" } }}>
        <TableCell sx={rowStyleMap}>
          <Box className='LogisticOperation__filtersBar__container__item__grouping' sx={{ width: '24px !important', height: '24px',
        backgroundColor: '#fff' }}>
            <CustomCheckbox
              // Checked if all nested orders are selected
              checked={item.orders.every((historyRow) =>
                selectedItems.some(i =>
                    (i._id + i.items._id) === (historyRow._id + historyRow.items._id)
                )
              )}
              onChange={(event) => handleTopLevelSelect(event, item)}
              icon={<CheckIcon />}
              checkedIcon={<CheckedIcon />}
            />
          </Box>
        </TableCell>
        

        {/* {userColumnsFields.includes('status') && <TableCell sx={rowStyleMap}></TableCell>} */}
        {userColumnsFields.includes('name') && <TableCell sx={rowStyleMap} scope="row" onClick={() => toggleRowOpen(item.sku)}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            {item.name.replace("Zumos Frescos", "").replace("bot/plast.", "")}
            <Box sx={{ width: '15px',}}>
              {openRows[item.sku] ? <svg width="15" height="30" viewBox="0 0 15 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.91421 11C1.02331 11 0.577142 12.0771 1.20711 12.7071L6.79289 18.2929C7.18342 18.6834 7.81658 18.6834 8.20711 18.2929L13.7929 12.7071C14.4229 12.0771 13.9767 11 13.0858 11H1.91421Z" fill="#4C4C4C" />
              </svg> :
              <svg width="15" height="30" viewBox="0 0 15 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.91421 19C1.02331 19 0.577142 17.9229 1.20711 17.2929L6.79289 11.7071C7.18342 11.3166 7.81658 11.3166 8.20711 11.7071L13.7929 17.2929C14.4229 17.9229 13.9767 19 13.0858 19H1.91421Z" fill="#4C4C4C" />
              </svg>}
            </Box>
          </Box>
        </TableCell>}
        {userColumnsFields.includes('quantity') && <TableCell sx={rowStyleMap} align="right">{parseFloat((item.totalQuantity)).toFixed(2)}</TableCell>}

        {userColumnsFields.includes('stock') && <TableCell sx={rowStyleMap} align="right">
          {!open ?
            <Box>
              {inputStock ? parseFloat(inputStock).toFixed(2) : 0}
            </Box>
            : <TextField
              color="success"
              type="number"
              value={inputStock}
              label={"Stock"}
              onChange={(e) => setInputStock(parseFloat(e.target.value))}                        
              sx={{ width: "100px" }}
              variant="standard"
              InputProps={{
                inputProps: {
                  style: { textAlign: "right" }, // Расположение текста по правой стороне
                },
              }}
            />
          }
        </TableCell>}

        {userColumnsFields.includes('reserve') && <TableCell sx={rowStyleMap} align="right">
          {!open ?
          <Box>
            {inputReserve || 0}
          </Box> :
          <TextField
            color="success"
            type="number"
            value={inputReserve}
            label={"Reserve"}
            onChange={(e) => setInputReserve(parseFloat(e.target.value))}                        
            sx={{ width: "100px" }}
            variant="standard"
            InputProps={{
              inputProps: {
                style: { textAlign: "right" }, // Расположение текста по правой стороне
              },
            }}
          />}
        </TableCell>}

        {userColumnsFields.includes('total') && <TableCell sx={{...rowStyleMap, textDecoration: "underline",color: (((inputStock) - (parseFloat(item.totalQuantity) + (inputReserve)))) >= 0 ? "red" : "black", fontWeight: "bold"}} align="right">{parseFloat(((inputStock) - (parseFloat(item.totalQuantity) + (inputReserve)))).toFixed(2)}</TableCell>}
        {userColumnsFields.includes('city') && <TableCell sx={{...rowStyleMap, background: '#eaf9ea !important'}} align="right">
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center', justifyContent: 'center', padding: '3px' }}>{navData?.map((el) => cityIconRender(el?.tradeName[0]))}</Box>
        </TableCell>}

        {userColumnsFields.includes('location/pav') && 
        <TableCell 
          sx={{...rowStyleMap, background: '#eaf9ea !important'}}
          align="right"
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'flex-start', justifyContent: 'center', padding: '3px' }}>
            {navData?.map((el, index) => renderLocation(el?.tradeName[0], el?.location, el?.pavilion, el.tradeName+index))}
          </Box>
        </TableCell>}

        {userColumnsFields.includes('proveedor') && <TableCell sx={{...rowStyleMap, background: '#eaf9ea !important' }} scope="row" align="center">
          {!open ? (
            <Box sx={{ fontWeight: 700, display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center', justifyContent: 'center', padding: '3px' }}>
              {navData?.map((el, index) =>  <Box key={index}>{el?.employee ? el?.employee.replace(/\([^)]*\)/g, '')?.replace(/\s+/g, ' ')?.trim() : ''}</Box>)}
            </Box>
          ) : (
            <FormControl sx={{ m: 1, width: 300 }} color="success" variant="standard">
              <Autocomplete
                multiple
                options={pavObj}
                getOptionLabel={(option) => {
                  let label = option.employee || option.name ? option.tradeName + " - " + (option.employee || option.name)  + "" : option.tradeName
                  return label || ""
                }}
                value={selectProveedor}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) => {
                    const searchStr = inputValue.toLowerCase();
                    if(option.tradeName){
                      return (
                        option.name?.toLowerCase().includes(searchStr) ||
                        option.tradeName?.toLowerCase().includes(searchStr) ||
                        option.pavilion?.toLowerCase().includes(searchStr) ||
                        option.employee?.toLowerCase().includes(searchStr)
                      );
                    }else{
                      return false
                    }
                  });
                }}
                onChange={(event, newValue) => {
                  setSelectProveedor(newValue);
                  setInputProveedor(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Proveedor"
                    variant="standard"
                    color="success"
                  />
                )}
              />
            </FormControl>
          )}
        </TableCell>}

        {userColumnsFields.includes('cogs') && <TableCell sx={rowStyleMap} align="right">{item.orders.reduce((accumulator, currentValue) => parseFloat(currentValue.items.marketPriceCP) + accumulator, 0).toFixed(2) + "€"}</TableCell>}

        {userColumnsFields.includes('buyer') && <TableCell sx={rowStyleMap} align="center"  >
          <Modal open={changeComprador} onClose={() => setChangeComprador(false)}>
            <Box
              sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '400px',
                  maxHeight: '500px',
                  overflow: 'auto',
                  bgcolor: 'background.paper',
                  border: '2px solid #000',
                  boxShadow: 24,
                  pr: 3,
                  pl: 3,
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-around',
                  flexWrap: "wrap"
              }}
            >
              <List dense sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                <Button onClick={() => handleSaveComprador()} sx={{ marginTop: '10px', position: "sticky", top: "10px", '&:hover': { opacity: 1 } }} variant='contained' fullWidth>
                  Save
                </Button>
                <Button onClick={() => setChangeModal(true)} sx={{ marginTop: '10px' }} variant='contained' fullWidth>
                  Edit
                </Button>
                <Button onClick={() => setCreateModal(true)} sx={{ marginTop: '10px', marginBottom: "10px" }} variant='contained' fullWidth>
                  Add new
                </Button>
                {drivers && [...drivers].map((value, ind) => {
                  const labelId = `checkbox-list-secondary-label-${value._id}`;
                  return value?.name && (
                    <ListItem
                      key={value?._id}
                      secondaryAction={
                        <Checkbox
                          edge="end"
                          color="success"
                          onChange={handleToggle(value)}
                          checked={[...checked].find(e => e?._id === value?._id)}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />}
                      disablePadding
                    >
                      <Button
                        edge="end"
                        onClick={(e) => {
                          handleSendDriverInformSendWhatsapp(value, value)
                        }}
                        size='small'
                        variant='contained'
                        sx={{ m: 1 }}
                      >
                        <WhatsAppIcon />
                      </Button>
                      <Button
                        edge="end"
                        onClick={(e) => {
                          handleSendDriverInformSendWhatsapp(value, value, "telegram")
                        }}
                        size='small'
                        variant='contained'
                        sx={{ m: 1 }}
                      >
                        <TelegramAppIcon />
                      </Button>
                      <ListItemButton >
                        <ListItemAvatar >
                          <Avatar
                            alt={`Avatar n°${value._id}`}
                            {...stringAvatar(value?.name ? value.name : "No Name")}
                            //src={`https://avatars.githubusercontent.com/u/19550456`}
                          />
                        </ListItemAvatar>
                        <ListItemText id={labelId} primary={`${value?.name ? value.name + " - " + value.phone : value.phone}`} />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
                <Box>
                  <Modal
                      open={changeModal}
                      onClose={() => {
                          setChangeModal(false)
                      }}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 300,
                        height: 300,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Select value={selectedContact} onChange={(e) => setSelectedContact(e.target.value)} sx={{ width: '100%' }}>
                        {drivers &&
                        [...drivers].map((driver) => driver?.name && (
                          <MenuItem onClick={() => {setSelectedContactPhone(driver?.phone); setSelectedContactName(driver?.name)}} key={driver._id} value={driver}>
                            {driver.name}
                          </MenuItem>
                        ))}
                      </Select>
                      <TextField
                        value={selectedContactName}
                        label={"Name"}
                        onChange={(e) => setSelectedContactName(e.target.value)}
                        sx={{ width: '100%' }}
                      />
                      <TextField
                        value={selectedContactPhone}
                        label={"Phone"}
                        onChange={(e) => setSelectedContactPhone(e.target.value)}
                        sx={{ width: '100%' }}
                      />
                      <Button onClick={() => handleUpdateDriver()} variant='contained' fullWidth>
                        Save
                      </Button>
                      <Button onClick={() => handleDeleteDriver()} variant='contained' color='error' fullWidth>
                        Delete
                      </Button>
                    </Box>
                  </Modal>

                  {/*add new*/}
                  <Modal open={createModal} onClose={() => setCreateModal(false)}>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 300,
                        height: 300,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <TextField value={createName} onChange={(e) => setCreateName(e.target.value)} sx={{ width: '100%' }} label='Name' />
                      <TextField value={createPhone} onChange={(e) => setCreatePhone(e.target.value)} sx={{ width: '100%' }} label='Phone' />
                      <Button onClick={() => handleCreateDriver()} variant='contained' fullWidth>
                        Create
                      </Button>
                    </Box>
                </Modal>
                </Box>
              </List>
            </Box>
          </Modal>
          <Box align="center" sx={{display: "flex", justifyContent: 'center'}}>
            {drivers && checked?.length ?
            <AvatarGroup sx={{justifyContent: "center"}} max={3} align="left" onClick={() => {setChangeComprador(prev => !prev); setChangeCompradorOrderId(item.orders)}}>
              {checked.map(el => <Avatar key={el._id} {...stringAvatar(el?.name ? el.name : "No Name")} sx={{ width: '30px', height: '30px', fontSize: '10px' }}/>)}
            </AvatarGroup>
            : <Avatar onClick={() => {setChangeComprador(prev => !prev); setChangeCompradorOrderId(item.orders)}} align="center" sx={{ backgroundColor: "purple", display: "flex", justifyContent: "center", width: '30px', height: '30px', fontSize: '10px'}}>+</Avatar>}
          </Box>
        </TableCell>}
        {userColumnsFields.includes('action') && <TableCell sx={rowStyleMap} align="right">
          {open ?
            <button className='saveBtn' color='primary' onClick={() => {
                setOpen(false)
                handleSaveEditInform()
            }}> {/*saveSpoPrice(row)*/}
              Save
            </button>
            : <button className='editBtn' color='primary' onClick={() => setOpen(true)}> {/*saveSpoPrice(row)*/}
              Edit
            </button>
          }
        </TableCell>}
      </TableRow>
      <TableRow>
        <TableCell sx={rowStyleMap} style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={openRows[item.sku]} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases" className='IProducAccordTable__subTable'>
                <TableHead sx={rowStyleMap}>
                  <TableRow>
                    <TableCell>Client</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Order ID</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                    <TableCell align="right">Stock</TableCell>
                    <TableCell align="right">Reserve</TableCell>
                    <TableCell align="right">Total</TableCell>
                    <TableCell align="right">Delivery Date</TableCell>
                    <TableCell align="right">Total price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.orders.map((historyRow) => (
                    <TableRow key={historyRow._id + historyRow.items._id}>
                      <TableCell sx={rowStyleMap}>{historyRow.userAcc.name + (" (" + historyRow.tradeName || historyRow.userAcc.tradeName) + ")"}</TableCell>
                      <TableCell sx={rowStyleMap} align='right'>
                        <StatusBuy item={historyRow} statuses={statuses} statusBackground={statusBackground} />
                      </TableCell>

                      <TableCell sx={rowStyleMap} align="center">
                        <Link target="_blank" href={"/admin/orders/" + historyRow._id}>
                          {historyRow._id.slice(-6)}
                        </Link>
                      </TableCell>
                      <TableCell sx={rowStyleMap} align="right">
                          {(historyRow.items.quantity).toFixed(2) + " " + historyRow.items.unit}
                      </TableCell>
                      <TableCell sx={rowStyleMap} align="right">
                          {((inputStock)?.toFixed(2) || 0) + " " + historyRow.items.unit}
                      </TableCell>
                      <TableCell sx={rowStyleMap} align="right">
                          {(inputReserve || 0)?.toFixed(2) + " " + historyRow.items.unit}
                      </TableCell>
                      <TableCell sx={rowStyleMap} align="right">
                          {(((((inputStock)?.toFixed(2) || 0) - (parseFloat(historyRow.items.quantity) + inputReserve))) || ((((inputStock)?.toFixed(2) || 0) - (parseFloat(historyRow.items.quantity))))) + " " + historyRow.items.unit}
                      </TableCell>
                      <TableCell sx={rowStyleMap} align="right">{historyRow.deliveryDate + " " + historyRow.deliveryTime}</TableCell>

                      <TableCell sx={rowStyleMap} align="right">
                          {parseFloat(historyRow.items.ourPrice).toFixed(2)  + "€"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default ItemsProductionAccordionItem;